import { notCachefetchJson } from "../utils";
import { generalAction } from "./general-slice";

export const changeActiveLessonId = (lessonId, studyGroupId, lessonName) => {

  return async (dispatch, getState) => {
    try {
      // const state = getState();

      // if (state.auth.user.isStudent && state.general.activeLessons[studyGroupId] !== lessonId)
      //   lessonsApi.lessonsUserActiveLessonChangeGet({
      //     lessonId: lessonId,
      //     studyGroupId: studyGroupId,
      //     lessonName: lessonName
      //   }, async (error, resdata, response) => {
      //     if (error) {
      //       dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "lessonsUserActiveLessonChangeGet " + error.message, level: 1, component: "general-actions", line: 14 }))
      //     }
      //     else {
      //       dispatch(generalAction.change({
      //         lessonId: lessonId,
      //         studyGroupId: studyGroupId
      //       }))
      //     }
      //   })
    }
    catch (e) {
      console.error(e);
    }

  }
}

export const getGeneral = () => {
  return async (dispatch) => {
      try {
          let res = await notCachefetchJson(window.config.uiData)
          if (res) {
              dispatch(generalAction?.initUiData(res));
          }
      }
      catch (e) {
      }
  }
}